import { Box, Stack, Switch, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Popover } from '@/components/utils/Popover/Popover';

type DndSettingsProps = {
    reusable: boolean;
};

interface Props {
    anchorEl: HTMLElement | null;
    value: DndSettingsProps;
    onClose: () => void;
    onUpdate: (settings: DndSettingsProps) => void;
    slotProps?: { paper?: { sx?: object; ref: React.Ref<HTMLDivElement> } };
}

export const DndSettingsPopover: React.FC<Props> = ({ anchorEl, onClose, onUpdate, value, slotProps }) => {
    const { t } = useTranslation();

    const open = Boolean(anchorEl);

    return (
        <Popover
            title={t('slide.components.dnd.tooltip.settings')}
            open={open}
            anchorEl={anchorEl}
            onClose={() => onClose()}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: -8,
                horizontal: 'center',
            }}
            slotProps={slotProps}
        >
            <Stack spacing={1}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                    <Switch
                        size='small'
                        onChange={(e) => {
                            const isReusable = e.target.checked;
                            onUpdate?.({ ...value, reusable: isReusable });
                        }}
                        checked={value.reusable || false}
                    />
                    <Typography variant='body1' sx={{ ml: 1 }}>
                        {t('slide.components.dnd.settings.reusableDragObject')}
                    </Typography>
                </Box>
            </Stack>
        </Popover>
    );
};
